<template>
    <el-table :data="huonekortit">
        <el-table-column prop="tilanimike.nimi" label="Tilanimike" width="200"/>
        <el-table-column prop="toiminta" label="Täsmennys" width="200"/>
        <el-table-column label="Henkilömäärä norm." width="160">
            <template #default="scope">
                <el-input-number
                    v-if="editedId == scope.row.id && editedHuonekortti"
                    v-model="editedHuonekortti.henkilomaaraNorm"
                    :min="0"
                    size="small"
                    style="width: 100%"/>
                <span v-else>{{ scope.row.henkilomaaraNorm }}</span>
            </template>
        </el-table-column>
        <el-table-column label="Henkilömäärä max" width="160">
            <template #default="scope">
                <el-input-number
                    v-if="editedId == scope.row.id && editedHuonekortti"
                    v-model="editedHuonekortti.henkilomaaraMax"
                    :min="0"
                    size="small"
                    style="width: 100%"/>
                <span v-else>{{ scope.row.henkilomaaraMax }}</span>
            </template>
        </el-table-column>
        <el-table-column label="Toiminta-aika" width="150">
            <template #default="scope">
                <el-select
                    v-if="editedId == scope.row.id && editedHuonekortti"
                    v-model="editedHuonekortti.toimintaAika"
                    allow-create
                    filterable
                    placeholder="Valitse tai kirjoita"
                    size="small"
                    style="width: 100%">
                    <el-option
                        v-for="item in toimintaAika"
                        :key="item"
                        :label="item"
                        :value="item"/>
                </el-select>
                <span v-else>{{ scope.row.toimintaAika }}</span>
            </template>
        </el-table-column>
        <el-table-column label="Sähköluokka" width="120">
            <template #default="scope">
                <el-select
                    v-if="editedId == scope.row.id && editedHuonekortti"
                    v-model="editedHuonekortti.sahkoluokka"
                    placeholder="Valitse"
                    size="small"
                    style="width: 100%">
                    <el-option
                        v-for="luokka in sahkoluokat"
                        :key="luokka"
                        :label="luokka"
                        :value="luokka"/>
                </el-select>
                <span v-else>{{ scope.row.sahkoluokka }}</span>
            </template>
        </el-table-column>
        <el-table-column label="Muokkaa" width="100px">
            <template #default="scope">
                <template v-if="loading && !updateSuccess.includes(scope.row.id) && !updateErrors.includes(scope.row.id)">
                    <el-icon class="is-loading">
                        <Loading />
                    </el-icon>
                </template>
                <template v-else-if="updateErrors.includes(scope.row.id)">
                    <el-icon style="color: var(--el-color-danger)">
                        <CircleClose />
                    </el-icon>
                </template>
                <template v-else-if="updateSuccess.includes(scope.row.id)">
                    <el-icon style="color: var(--el-color-success)">
                        <Check />
                    </el-icon>
                </template>
                <template v-else-if="editedId == scope.row.id">
                    <ComCancelIconButton size="small" @click="peruutaMuokkaus"/>
                    <ComSaveButton size="small" @click="tallennaMuokkaus"/>
                </template>
                <ComEditButton v-else type="primary" size="small" @click="muokkaaHuonekorttia(scope.row)"/>
            </template>
        </el-table-column>
    </el-table>
</template>


<script setup lang="ts">
import ComEditButton from '@/components/common/buttons/ComEditButton.vue';
import ComCancelIconButton from '@/components/common/buttons/ComCancelIconButton.vue';
import ComSaveButton from '@/components/common/buttons/ComSaveButton.vue';
import { HuonekorttiSahkoluokka } from '@/api/models/huonekortti-sahkoluokka';
import { Loading, Check, CircleClose } from '@element-plus/icons-vue';
import ToimintaAika from '@/types/ToimintaAikaEnum';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';

const {
    huonekortit,
    editedHuonekortti,
    editedId,
    loading,
    updateSuccess,
    updateErrors,
    muokkaaHuonekorttia,
    peruutaMuokkaus,
    tallennaMuokkaus
} = useHuonekorttiMuokkausComponent()
const sahkoluokat = Object.values(HuonekorttiSahkoluokka)
const toimintaAika = ToimintaAika
</script>
